import Axios from "axios";
import { DeviceUUID } from "device-uuid";

async function requestIpData(): Promise<string> {
  try {
    const res = await Axios.get(
      process.env.REACT_APP_LOCATION_ENDPOINT as string
    );

    return res.data.IPv4;
  } catch (error) {
    return "noIP";
  }
}

async function getDeviceId(): Promise<string> {
  const deviceIp: string = await requestIpData();
  const deviceUUID: string = new DeviceUUID().get();

  return `${deviceIp}-${deviceUUID}`;
}

export { getDeviceId };
